import type {
  VideoAction,
} from '../types';

import * as actionTypes from './actionTypes';

type VideosOrder = 'recent' | 'oldest';
type VideosScope = 'all' | 'mine' | 'gymcloud' | 'vimeo' | 'youtube';
type VideoRequestParams = {
  q?: string,
  page?: number,
  order?: VideosOrder,
  scope?: VideosScope,
  perPage?: number,
  userId?: number,
};

export const requestGetVideos = ({
  q = '',
  page = 1,
  perPage = 25,
  list,
}: VideoRequestParams & {
  list: string,
}): VideoAction => ({
  type: actionTypes.REQUEST_GET_VIDEOS,
  params: {
    q,
    page,
    per_page: perPage,
  },
  list,
});

export const requestPersonalVideos = ({
  q = '',
  userId,
  page = 1,
  perPage = 25,
  list,
}: VideoRequestParams & {
  list: string,
} = {}): VideoAction => ({
  type: actionTypes.REQUEST_GET_VIDEOS,
  params: {
    q,
    user_id: userId,
    page,
    per_page: perPage,
  },
  list,
});

export const requestSearchVideo = ({
  q = '',
  scope = 'all',
  page = 1,
  perPage = 10,
}: VideoRequestParams = {}): VideoAction => ({
  type: actionTypes.REQUEST_SEARCH_VIDEO,
  params: {
    q,
    scope,
    page,
    per_page: perPage,
  },
});
